import React from 'react';

const HradminEmployeeViewUpdatePage = (props) => {
    return (
        <p>
            HradminEmployeeViewUpdatePage
        </p>
    )
}

export default HradminEmployeeViewUpdatePage;